import React from 'react';

interface VideoIconProps {
  style?: object;
  /** Rendered width/height in px. */
  size?: number;
}

/**
 * Colored video file icon, following the same document design language as
 * {@link WordIcon}/{@link ExcelIcon} (white sheet + grey outline + colored
 * accent block with a white play triangle). Used by `getFileIcon` for
 * `video/*`.
 */
export const VideoIcon: React.FC<VideoIconProps> = ({ style, size = 20 }) => (
  <svg
    role="presentation"
    focusable="false"
    aria-hidden="true"
    viewBox="0 0 32 32"
    width={size}
    height={size}
    style={style}
  >
    <path d="M9.5 29H28.5C28.775 29 29 28.775 29 28.5V9H24.5C23.673 9 23 8.327 23 7.5V3H9.5C9.225 3 9 3.225 9 3.5V28.5C9 28.775 9.225 29 9.5 29Z" fill="white" />
    <path d="M28.293 8.00003L24 3.70703V7.50003C24 7.77503 24.225 8.00003 24.5 8.00003H28.293Z" fill="white" />
    <path opacity="0.64" fillRule="evenodd" clipRule="evenodd" d="M29.56 7.854L24.146 2.439C23.8642 2.15891 23.4833 2.00117 23.086 2H9.5C8.673 2 8 2.673 8 3.5V28.5C8 29.327 8.673 30 9.5 30H28.5C29.327 30 30 29.327 30 28.5V8.914C30 8.514 29.844 8.137 29.56 7.854ZM24 3.707L28.293 8H24.5C24.2241 7.99945 24.0005 7.77591 24 7.5V3.707ZM9.5 29H28.5C28.775 29 29 28.775 29 28.5V9H24.5C23.673 9 23 8.327 23 7.5V3H9.5C9.225 3 9 3.225 9 3.5V28.5C9.00055 28.7759 9.22409 28.9995 9.5 29Z" fill="#605E5C" />
    <path d="M3.5 25H14.5C15.3284 25 16 24.3284 16 23.5V12.5C16 11.6716 15.3284 11 14.5 11H3.5C2.67157 11 2 11.6716 2 12.5V23.5C2 24.3284 2.67157 25 3.5 25Z" fill="#0F6CBD" />
    <path d="M6.8 14.2L13 18L6.8 21.8Z" fill="#F9F7F7" />
  </svg>
);
